export const MuiInputLabel = {
    styleOverrides: {
        root: ({ theme })=>({
                color: theme.palette.grey[600]
            }),
        sizeSmall: {
            top: '-3px'
        },
        shrink: {
            top: '0px'
        }
    }
};

//# sourceMappingURL=input-label.js.map